// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ICounty {
    id: number;
    code: string;
    code2: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class County implements ICounty, IBaseType {
    public id: number;
    public code: string;
    public code2: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Apache  County
	**/
    get Apache(): ICounty {
        return this.FromId(1);
    }
    /**
		Returns Cochise  County
	**/
    get Cochise(): ICounty {
        return this.FromId(2);
    }
    /**
		Returns Coconino  County
	**/
    get Coconino(): ICounty {
        return this.FromId(3);
    }
    /**
		Returns Gila  County
	**/
    get Gila(): ICounty {
        return this.FromId(4);
    }
    /**
		Returns Graham  County
	**/
    get Graham(): ICounty {
        return this.FromId(5);
    }
    /**
		Returns Greenlee  County
	**/
    get Greenlee(): ICounty {
        return this.FromId(6);
    }
    /**
		Returns La Paz  County
	**/
    get LaPaz(): ICounty {
        return this.FromId(7);
    }
    /**
		Returns Maricopa  County
	**/
    get Maricopa(): ICounty {
        return this.FromId(8);
    }
    /**
		Returns Mohave  County
	**/
    get Mohave(): ICounty {
        return this.FromId(9);
    }
    /**
		Returns Navajo  County
	**/
    get Navajo(): ICounty {
        return this.FromId(10);
    }
    /**
		Returns Pima  County
	**/
    get Pima(): ICounty {
        return this.FromId(11);
    }
    /**
		Returns Pinal  County
	**/
    get Pinal(): ICounty {
        return this.FromId(12);
    }
    /**
		Returns Santa Cruz  County
	**/
    get SantaCruz(): ICounty {
        return this.FromId(13);
    }
    /**
		Returns Yavapai  County
	**/
    get Yavapai(): ICounty {
        return this.FromId(14);
    }
    /**
		Returns Yuma  County
	**/
    get Yuma(): ICounty {
        return this.FromId(15);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, code: 'Apache', code2: '1', displayValue: 'Apache ', description: 'Apache County', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, code: 'Cochise', code2: '3', displayValue: 'Cochise ', description: 'Cochise County', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, code: 'Coconino', code2: '5', displayValue: 'Coconino ', description: 'Coconino County ', sortOrder: 3, active: true });
        this._dictionary.add('4', { id: 4, code: 'Gila', code2: '7', displayValue: 'Gila ', description: 'Gila County', sortOrder: 4, active: true });
        this._dictionary.add('5', { id: 5, code: 'Graham', code2: '9', displayValue: 'Graham ', description: 'Graham County', sortOrder: 5, active: true });
        this._dictionary.add('6', { id: 6, code: 'Greenlee', code2: '11', displayValue: 'Greenlee ', description: 'Greenlee County', sortOrder: 6, active: true });
        this._dictionary.add('7', { id: 7, code: 'LaPaz', code2: '12', displayValue: 'La Paz ', description: 'La Paz County', sortOrder: 7, active: true });
        this._dictionary.add('8', { id: 8, code: 'Maricopa', code2: '13', displayValue: 'Maricopa ', description: 'Maricopa County ', sortOrder: 8, active: true });
        this._dictionary.add('9', { id: 9, code: 'Mohave', code2: '15', displayValue: 'Mohave ', description: 'Mohave County ', sortOrder: 9, active: true });
        this._dictionary.add('10', { id: 10, code: 'Navajo', code2: '17', displayValue: 'Navajo ', description: 'Navajo County ', sortOrder: 10, active: true });
        this._dictionary.add('11', { id: 11, code: 'Pima', code2: '19', displayValue: 'Pima ', description: 'Pima County', sortOrder: 11, active: true });
        this._dictionary.add('12', { id: 12, code: 'Pinal', code2: '21', displayValue: 'Pinal ', description: 'Pinal County', sortOrder: 12, active: true });
        this._dictionary.add('13', { id: 13, code: 'SantaCruz', code2: '23', displayValue: 'Santa Cruz ', description: 'Santa Cruz County', sortOrder: 13, active: true });
        this._dictionary.add('14', { id: 14, code: 'Yavapai', code2: '25', displayValue: 'Yavapai ', description: 'Yavapai County', sortOrder: 14, active: true });
        this._dictionary.add('15', { id: 15, code: 'Yuma', code2: '27', displayValue: 'Yuma ', description: 'Yuma County', sortOrder: 15, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ICounty {
        return this._dictionary[id];
    }

    public FromCode(code: string): ICounty {
        var match = this._dictionary.getValues().filter(d => d.value == code);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ICounty[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ICounty[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ICounty[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
